<script lang="js" setup>
</script>

<template>
  <div class="flex flex-col rounded-[20px] bg-card-light-gray p-7.5 ring-1 ring-card-light-gray-outline dark:bg-card-gray dark:ring-card-gray-outline">
    <slot />
  </div>
</template>
